<template>
  <li class="list-group-item">
    <label>{{ tab.objectname }}</label>
    <input
      type="checkbox"
      v-model="checkedValue"
      @change="modifyTabAccessData(tab)"
      class="float-right"
    />
  </li>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Tabs",
  props: {
    tab: Object,
    userId: Number,
    tabActive: Boolean,
    collectDataHandlerTabs: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      checkedValue: false,
    };
  },
  computed: {
    isActive() {
      return this.checkedValue;
    },
  },
  mounted() {
    this.checkedValue = this.tabActive;
  },
  methods: {
    ...mapActions({
      modifyUserAccessData: "modifyUserAccessData",
      getEditedUserAccessDetails: "getEditedUserAccessDetails",
    }),
    async modifyTabAccessData(bucketobj) {
      // console.log("Access", this.isActive);
      // console.log("Tab info:", bucketobj);
      let chartaccessdata = {
        objectname: bucketobj.objectname,
        is_visible: this.isActive,
        is_downloadable: this.isActive,
        read_only: this.isActive,
        userId: this.userId,
        object_id: bucketobj.id,
      };
      // console.log("tabssssssssss", chartaccessdata);
      this.$emit("collectDataHandlerTabs", chartaccessdata);
      // this.modifyUserAccessData(chartaccessdata);
      // await this.getEditedUserAccessDetails(this.userId);
    },
  },
};
</script>

<style></style>
